import {BaseControl} from './base-control';
import {PasswordControlInterface} from '../../interfaces';

export class PasswordControl extends BaseControl {
    public hintDisabled: boolean;

    constructor(data: PasswordControlInterface) {
        super(data);

        this.hintDisabled = data.hintDisabled;
    }
}
